import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const EmploymentProfileOnboardingPageLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/EmploymentProfileOnboardingPage" */
      './EmploymentProfileOnboardingPage'
    ),
});
